import type { AppRibbonProps } from 'owa-app-ribbon';
import { getMailCommandRibbonProps } from './getMailCommandRibbonProps';
import categoryStore from 'owa-categories/lib/store/store';
import moveToStore from 'owa-mail-moveto-control/lib/store/store';
import { owaComputedFn } from 'owa-computed-fn';
import { MailAttachmentPickers } from 'owa-attachment-pickers';
import { LazyRibbonCustomizer } from 'owa-mail-ribbon-customizer';
import { MAIN_WINDOW_ID } from './store/menuDefinitionStore';

export const mailAppRibbonProps: AppRibbonProps = {
    getRibbonProps: getMailCommandRibbonProps,
    renderExtraElements: owaComputedFn((attachmentInlinePickers, attachmentMultiPickers) => (
        <>
            <MailAttachmentPickers
                attachmentInlinePickers={attachmentInlinePickers}
                attachmentMultiPicker={attachmentMultiPickers}
            />
            <LazyRibbonCustomizer />
        </>
    )),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function get called at module scope is not allowed. This may cause unwanted side effects. */
    ribbonPropsDependency1: categoryStore().categoryMenuViewState.findText,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function get called at module scope is not allowed. This may cause unwanted side effects. */
    ribbonPropsDependency2: moveToStore().findTextMap.get(MAIN_WINDOW_ID),
};
